import logoSrc from "@/assets/komma-logo.png";

export const KommaLogo = ({ size = 56, className = "", "data-testid": tid = "komma-logo" }) => (
    <img
        src={logoSrc}
        alt="Komma Associates"
        width={size}
        height={size}
        className={`object-contain ${className}`}
        style={{ imageRendering: "auto" }}
        data-testid={tid}
    />
);

export const KommaLogoMark = ({ size = 40, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <KommaLogo size={size} data-testid="komma-logo-mark" />
    </div>
);

export default KommaLogo;
